/* Sitewide dnp shell (2026-09-27). Loaded by layout/dnp-site and layout/dnp.
   Mobile menu: dnp.js toggles .drawer.is-open; this pins the drawer to the real header
   bottom (announcement/header heights differ by breakpoint and scroll), locks page scroll
   while open, and closes it on Escape, link taps and resize to desktop. */
(() => {
  const burger = document.querySelector('.hdr__burger');
  const drawer = document.querySelector('.drawer');
  const hdr = document.querySelector('#s02-header');
  if (!burger || !drawer || !hdr) return;
  const root = document.documentElement;
  const place = () => {
    const b = Math.max(0, Math.round(hdr.querySelector('.hdr__inner').getBoundingClientRect().bottom));
    drawer.style.setProperty('--drawer-top', b + 'px');
  };
  const isOpen = () => drawer.classList.contains('is-open');
  new MutationObserver(() => {
    if (isOpen()) { place(); root.classList.add('menu-open'); }
    else root.classList.remove('menu-open');
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  // dnp.js only wires #anchor links; every drawer link closes the menu
  drawer.querySelectorAll('a:not([href^="#"])').forEach((a) => a.addEventListener('click', () => { if (isOpen()) burger.click(); }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) burger.click(); });
  const mq = window.matchMedia('(min-width: 750px)');
  const onMq = () => { if (mq.matches && isOpen()) burger.click(); };
  mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);
  window.addEventListener('resize', () => { if (isOpen()) place(); });
  place();
})();

/* Cart page: qty steppers submit the form so totals come from Shopify, not client math */
(() => {
  const form = document.querySelector('[data-cart-page]');
  if (!form) return;
  form.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    e.preventDefault();
    const i = b.parentElement.querySelector('input');
    i.value = Math.max(0, (parseInt(i.value, 10) || 0) + parseInt(b.dataset.step, 10));
    form.submit();
  });
  form.addEventListener('change', (e) => { if (e.target.matches('input[name="updates[]"]')) form.submit(); });
})();

/* Instruction manual: highlight the step chip for the section in view */
(() => {
  const chips = document.querySelectorAll('.man__toc a');
  if (!chips.length || !('IntersectionObserver' in window)) return;
  const map = new Map([...chips].map((a) => [a.getAttribute('href').slice(1), a]));
  const io = new IntersectionObserver((es) => es.forEach((en) => {
    if (!en.isIntersecting) return;
    chips.forEach((c) => c.classList.remove('is-on'));
    const c = map.get(en.target.id); if (c) c.classList.add('is-on');
  }), { rootMargin: '-40% 0px -55% 0px' });
  map.forEach((_, id) => { const el = document.getElementById(id); if (el) io.observe(el); });
})();

/* Inline email signup -> Klaviyo client subscriptions API (list + company id come from the section) */
(() => {
  document.querySelectorAll('[data-su]').forEach((sec) => {
    const f = sec.querySelector('form'), msg = sec.querySelector('.su__msg'), btn = f.querySelector('button');
    f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = f.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = 'Please enter a valid email.'; msg.className = 'su__msg is-err'; return; }
      btn.disabled = true; msg.textContent = ''; msg.className = 'su__msg';
      try {
        const r = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(sec.dataset.company), {
          method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: sec.dataset.source + ' (' + location.pathname + ')', profile: { data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: sec.dataset.list } } } } })
        });
        if (r.status !== 202 && !r.ok) throw new Error(r.status);
        f.reset(); msg.textContent = "You're on the list. Check your inbox."; msg.className = 'su__msg is-ok';
      } catch (err) { msg.textContent = 'Something went wrong. Please try again.'; msg.className = 'su__msg is-err'; }
      btn.disabled = false;
    });
  });
})();
